import { Apartment } from '@/models/apartment.model';
import { Detail } from '@/models/app.model';

class ApartmentService {
    apartment: Apartment = {
        internalNumber: '',
        area: 0,
        rooms: '0',
        floor: '-1',
        id: 0,
        status: '',
        symbol: '',
        name: '',
        mappingName: '',
    };

    public setData(apartment: Apartment) {
        this.apartment = apartment;
    }

    public get isDefined() {
        return !!this.apartment;
    }

    public getDetails() {
        let roomsTranslationText = 'pokój';
        if (Number(this.apartment.rooms) >= 2 && Number(this.apartment.rooms) <= 4) {
            roomsTranslationText = 'pokoje';
        } else if (Number(this.apartment.rooms) > 4) {
            roomsTranslationText = 'pokoi';
        }

        const datails: Array<Detail> = [
            {
                value: this.apartment.name,
                translate: '',
            },
            {
                value: `${this.apartment.area} m<sup>2</sup>`,
                translate: '',
            },
            {
                value: this.apartment.rooms,
                translate: roomsTranslationText,
            },
            {
                value: Number(this.apartment.floor) > 0 ? this.apartment.floor : '',
                translate: Number(this.apartment.floor) > 0 ? 'piętro' : 'parter',
            },
        ];

        return datails;
    }
}

export default ApartmentService;
